<template>
	<div>
		<v-container v-if="missingRecord">
			<v-row justify="center">
				<v-col cols="12" sm="8" md="6" lg="4">
					<v-card>
						<v-card-title primary-title>
							<v-spacer></v-spacer>
							<div>حصل خطا</div>
							<v-spacer></v-spacer>
						</v-card-title>
						<v-card-text>
							<v-row dense>
								<v-col cols="12" class="text-center">الرجاء التواصل مع الإدارة</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<v-container v-else>
			<v-breadcrumbs :items="breadcrumbs">
					<template #divider>
						<v-icon>mdi-chevron-left</v-icon>
					</template>
				</v-breadcrumbs>

			<v-stepper v-model="step" :alt-labels="$vuetify.breakpoint.mdAndDown">
				<v-stepper-header>
					<v-stepper-step
						:editable="consent && step > 0"
						edit-icon="mdi-check"
						:complete="step > 1"
						step="1"
					>
						المعلومات الأساسية
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step
						:editable="consent && (isEdit || added)"
						edit-icon="mdi-check"
						:complete="step > 2"
						step="2"
					>
						بيانات البديل
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step
						:editable="consent && (isEdit || added)"
						edit-icon="mdi-check"
						:complete="step > 3"
						step="3"
					>
						بيانات الاتصال
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step
						:editable="consent && (isEdit || added)"
						edit-icon="mdi-check"
						:complete="step > 4"
						step="4"
					>
						ايصال الدفع
					</v-stepper-step>
				</v-stepper-header>

				<v-stepper-items>
					<v-stepper-content step="0">
						<v-form v-model="valid0">
							<v-row dense>
								<v-col cols="12" class="text-center text-h5 pb-4">الإقرار</v-col>
								<v-col cols="12">
									<v-skeleton-loader v-if="!conditions" type="paragraph@2"></v-skeleton-loader>
									<pre v-else>{{ conditions }}</pre>
								</v-col>
								<v-col v-if="conditions" cols="12">
									<v-checkbox
										v-model="consent"
										hide-details="auto"
										label="أقر بأنني قرأت نص الإقرار المذكور أعلاه وأوافق على ذلك"
										:rules="[rules.required]"
									></v-checkbox>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn color="primary" :disabled="!valid0 || !conditions" @click="step = 1">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<v-stepper-content step="1">
						<v-form v-model="valid1">
							<v-row no-gutters>
								<v-col cols="12">
									<v-row no-gutters>
										<v-col cols="12" md="6" class="pa-2">
											<v-select
												v-model="newRecord.country"
												outlined
												hide-details="auto"
												label="الدولة"
												:items="countries"
												:disabled="true"
												item-text="name"
												item-value="countryID"
												:rules="[rules.required]"
											></v-select>
										</v-col>
										<v-col cols="12" md="6" class="pa-2">
											<v-select
												v-model="newRecord.region"
												outlined
												hide-details="auto"
												label="المنطقة"
												:items="regions"
												item-text="name"
												item-value="regionID"
												:rules="[rules.required]"
											></v-select>
										</v-col>
										<v-col cols="12" md="6" class="pa-2">
											<v-select
												v-model="newRecord.city"
												outlined
												hide-details="auto"
												label="المدينة"
												:items="cities"
												item-text="name"
												item-value="cityID"
												:rules="[rules.required]"
											></v-select>
										</v-col>
										<v-col cols="12" md="6" class="pa-2">
											<v-select
												v-model="newRecord.place"
												outlined
												hide-details="auto"
												label="مقر العمل"
												:items="places"
												item-text="name"
												item-value="id"
												:rules="[rules.required]"
											>
												<template v-if="newRecord.city" #prepend-item>
													<v-list-item @click="showAddNewHospital = true">
														<v-list-item-title>إضافة مستشفى جديد</v-list-item-title>
														<v-list-item-action>
															<v-icon>mdi-plus</v-icon>
														</v-list-item-action>
													</v-list-item>
												</template>
											</v-select>
										</v-col>

										<v-col cols="12" class="pa-2">
											<v-checkbox v-model="isOther" label="ملاك الوظيفة غير مكان العمل" hide-details></v-checkbox>
										</v-col>

										<v-col v-if="isOther" cols="12" md="6" class="pa-2">
											<v-select
												v-model="newRecord.country3"
												outlined
												hide-details="auto"
												label="الدولة"
												:disabled="true"
												:items="countries"
												item-text="name"
												item-value="countryID"
												:rules="[rules.required]"
											></v-select>
										</v-col>
										<v-col v-if="isOther" cols="12" md="6" class="pa-2">
											<v-select
												v-model="newRecord.region3"
												outlined
												hide-details="auto"
												label="المنطقة"
												:items="regions3"
												item-text="name"
												item-value="regionID"
												:rules="[rules.required]"
											></v-select>
										</v-col>
										<v-col v-if="isOther" cols="12" md="6" class="pa-2">
											<v-select
												v-model="newRecord.city3"
												outlined
												hide-details="auto"
												label="المدينة"
												:items="cities3"
												item-text="name"
												item-value="cityID"
												:rules="[rules.required]"
											></v-select>
										</v-col>
										<v-col v-if="isOther" cols="12" md="6" class="pa-2">
											<v-select
												v-model="newRecord.place3"
												outlined
												hide-details="auto"
												label="ملاك العمل"
												:items="places3"
												item-text="name"
												item-value="id"
												:rules="[rules.required]"
											>
												<template v-if="newRecord.city3" #prepend-item>
													<v-list-item @click="showAddNewHospital2 = true">
														<v-list-item-title>إضافة مستشفى جديد</v-list-item-title>
														<v-list-item-action>
															<v-icon>mdi-plus</v-icon>
														</v-list-item-action>
													</v-list-item>
												</template>
											</v-select>
										</v-col>

										<v-col cols="12" md="6" class="pa-2">
											<div>نوع البديل</div>
											<v-radio-group
												v-model="newRecord.gender"
												hide-details
												active-class="font-weight-bold primary--text"
												:rules="[rules.required]"
											>
												<v-radio label="بديل أو بديلة" value="both"></v-radio>
												<v-radio label="بديل" value="male"></v-radio>
												<v-radio label="بديلة" value="female"></v-radio>
											</v-radio-group>
										</v-col>
										<v-col cols="12" md="6" class="pa-2">
											<div>نوع الوظيفة</div>
											<v-radio-group
												v-model="newRecord.type"
												hide-details
												active-class="font-weight-bold primary--text"
												:rules="[rules.required]"
											>
												<v-radio label="خدمة مدنية" value="خدمة مدنية"></v-radio>
												<v-radio label="تشغيل ذاتي" value="تشغيل ذاتي"></v-radio>
												<v-radio label="غير ذلك" value="other"></v-radio>
											</v-radio-group>
											<v-text-field
												v-if="newRecord.type == 'other'"
												v-model="newRecord.typeWritten"
												class="pt-2"
												outlined
												hide-details="auto"
												label="نوع الوظيفة"
												:rules="[rules.required]"
											></v-text-field>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-autocomplete
												v-model="newRecord.specialty"
												outlined
												hide-details="auto"
												label="التخصص الأساسي"
												:items="specialties"
												item-text="name"
												item-value="specialtiesID"
												:rules="[rules.required]"
											>
												<template #append-item>
													<v-list-item @click="showAddNewSpecialty = true">
														<v-list-item-title>إضافة فئة جديدة</v-list-item-title>
														<v-list-item-action>
															<v-icon>mdi-plus</v-icon>
														</v-list-item-action>
													</v-list-item>
												</template>

												<template #item="{ item }">
													<v-list-item-content>
														<v-list-item-title>
															{{ item.name }}
														</v-list-item-title>
														<v-list-item-subtitle v-if="item.femName" class="text-caption">
															{{ item.femName }}
														</v-list-item-subtitle>
													</v-list-item-content>
												</template>
											</v-autocomplete>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-text-field
												v-model="newRecord.section"
												outlined
												hide-details="auto"
												label="القسم الحالي (اختياري)"
											></v-text-field>
										</v-col>
										<v-col v-if="false" cols="12" class="pa-2">
											<v-textarea
												v-model="newRecord.note"
												:rows="3"
												outlined
												hide-details="auto"
												label="التفاصيل"
												:rules="[rules.maxLength250]"
												counter="250"
											></v-textarea>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" class="pa-2 text-center" order="3">
									<v-btn color="primary" :disabled="!valid1" :loading="loading" @click="submitStep1">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<v-stepper-content step="2">
						<v-form>
							<v-row no-gutters>
								<v-col cols="12" class="pa-2">
									التخصص الأساسي:
									<v-chip small>{{ specialtyName }}</v-chip>
									<div class="mb-2"></div>
									<v-autocomplete
										v-model="newRecord.secondarySpecialties"
										outlined
										hide-details="auto"
										label="تخصصات البديل الأخرى (اختياري)"
										:items="specialties"
										item-text="name"
										item-value="specialtiesID"
										:rules="[rules.limit3]"
										multiple
										chips
									>
										<template #item="{ item, on }">
											<v-list-item
												:disabled="item.specialtiesID == newRecord.specialty && newRecord.secondarySpecialties.indexOf(item.specialtiesID) == -1"
												v-on="on"
>
												<v-list-item-content :class="{'primay--text font-weight-bold': newRecord.secondarySpecialties.indexOf(item.specialtiesID) != -1}">
													<v-list-item-title>
														{{ item.name }}
													</v-list-item-title>
													<v-list-item-subtitle v-if="item.femName" class="text-caption">
														{{ item.femName }}
													</v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>
										</template>
									</v-autocomplete>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-combobox
										v-model="newRecord.requiredSections"
										:search-input.sync="search"
										outlined
										hide-details="auto"
										label="الأقسام المرغوب الإنتقال إليها (اختياري)"
										:items="sections"
										multiple
										chips
									>
									<template v-if="!search" #prepend-item>
										<v-list-item>
											<v-list-item-content>
												<v-list-item-title>
													لإضافة قسم جديد قم بكتابته ثم الضغط على زر 
													<kbd>enter</kbd>
													<small>&nbsp;(زر إضافة السطور)</small>
												</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-divider class="mt-2"></v-divider>
									</template>
									<template #no-data>
										<v-list-item>
											<v-list-item-content>
												<v-list-item-title>
													لإضافة 
													"<strong>{{ search }}</strong>",
													قم بالضغط على زر <kbd>enter</kbd>
													<small>&nbsp;(زر إضافة السطور)</small>
												</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</template>
								</v-combobox>
								</v-col>
								<v-col cols="12" class="py-3">
									<v-row align="center" no-gutters>
										<v-col cols="expand" class="py-0 px-4">
											<v-divider></v-divider>
										</v-col>
										<v-col cols="auto" class="pa-0 text-body-1">المدن المرغوب الإنتقال إليها</v-col>
										<v-col cols="expand" class="py-0 px-4">
											<v-divider></v-divider>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" md="6">
									<v-row no-gutters>
										<v-col cols="12" class="pa-2">
											<v-select
												v-model="recordCities.country"
												outlined
												hide-details="auto"
												label="الدولة"
												:disabled="true"
												:items="countries"
												item-text="name"
												item-value="countryID"
											></v-select>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-select
												v-model="recordCities.region"
												outlined
												hide-details="auto"
												label="المنطقة"
												:items="regions2"
												item-text="name"
												item-value="regionID"
											></v-select>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-autocomplete
												v-model="recordCities.cities"
												outlined
												hide-details="auto"
												label="المدينة"
												:items="cities2"
												item-text="name"
												item-value="cityID"
												multiple
												chips
												small-chips
												return-object
											>
												<template v-if="cities2.length" #prepend-item>
													<v-list-item ripple @click="toggleAll">
														<v-list-item-action>
															<v-icon :color="recordCities.cities > 0 ? 'primary' : ''">{{ icon }}</v-icon>
														</v-list-item-action>
														<v-list-item-content>
															<v-list-item-title>كل المدن</v-list-item-title>
														</v-list-item-content>
													</v-list-item>
													<v-divider class="mt-2"></v-divider>
												</template>
											</v-autocomplete>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-alert v-if="recordCities.cities.length > 1" type="info">
												لتحديد أماكن مفضلة, حدد مدينة واحدة
											</v-alert>
											<v-checkbox
												v-model="isFav"
												label="تحديد الأماكن المفضلة"
												:disabled="recordCities.cities.length > 1"
											></v-checkbox>
											<v-autocomplete
												v-model="recordCities.places"
												outlined
												hide-details="auto"
												label="مكان العمل"
												:disabled="!isFav || recordCities.cities.length > 1"
												:items="places2"
												item-text="name"
												item-value="placeID"
												multiple
												chips
												small-chips
												return-object
											></v-autocomplete>
										</v-col>
										<v-col v-if="isFav">
											<v-alert type="info" class="mx-2">
												لتأكيد إضافة منطقة العمل الرجاء الضغط على زر الإضافة بعد تحديد الأماكن المفضلة من حقل مكان العمل
											</v-alert>
										</v-col>
										<v-col cols="12" class="pa-2 text-center">
											<v-btn
												color="success"
												:loading="loading"
												:disabled="recordCities.cities.length == 0"
												@click="addRecordCities"
											>
												إضافة
												<v-icon right>mdi-plus</v-icon>
											</v-btn>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-row no-gutters>
										<v-col
											v-if="storedRecordCities.length || Object.keys(favHospitals).length"
											cols="12"
											class="pa-2 text-center"
										>
											<div v-if="Object.keys(favHospitals).length" class="pb-3">أماكن العمل المفضلة</div>
											<v-chip-group v-model="selectedForRemovalHospitals" column multiple>
												<template v-for="city in favHospitals">
													<template v-for="record in city.hospitals">
														<v-chip :key="record.id" :value="record.cityID" class="ma-1" filter>
															{{ city.name }} - {{ record.name }}
														</v-chip>
													</template>
												</template>
											</v-chip-group>
											<div v-if="storedRecordCities.length" class="pb-3">المدن المختارة</div>
											<v-chip-group v-model="selectedForRemoval" column multiple>
												<template v-for="record in storedRecordCities">
													<v-chip :key="record.cityID" :value="record.cityID" class="ma-1" filter>
														{{ record.name }}
													</v-chip>
												</template>
											</v-chip-group>
										</v-col>
										<v-col
											v-if="storedRecordCities.length || Object.keys(favHospitals).length"
											cols="12"
											class="pa-2 text-center"
										>
											<v-btn
												color="error"
												:loading="loading"
												:disabled="selectedForRemoval.length == 0 && selectedForRemovalHospitals.length == 0"
												@click="removeRecordCities"
											>
												حذف
												<v-icon right>mdi-cancel</v-icon>
											</v-btn>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn
										color="primary"
										:loading="loading"
										:disabled="storedRecordCities.length == 0 && Object.keys(favHospitals).length == 0"
										@click="submitStep2"
									>
										حفظ
									</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<v-stepper-content step="3">
						<v-form>
							<v-row no-gutters>
								<v-col cols="12" md="6" class="pa-2">
									<v-select
										v-model="newCommunication.type"
										outlined
										hide-details="auto"
										label="نوع الاتصال"
										:items="contactTypes"
										item-value="communicationTypeID"
										item-text="name"
									></v-select>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-text-field
										v-model="newCommunication.value"
										outlined
										hide-details="auto"
										label="المعرف"
										class="ltr-content"
										:rules="[rules.maxLength250]"
										counter="250"
									></v-text-field>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn
										color="success"
										:loading="loading"
										:disabled="!newCommunication.value || !newCommunication.type"
										@click="addContact"
									>
										إضافة
										<v-icon right>mdi-plus</v-icon>
									</v-btn>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-data-table hide-default-footer :headers="contactsHeaders" :items="communications">
										<template #[`item.value`]="{ item }">
											<div v-if="item.isEdit" dir="ltr" class="text-end">
												<v-text-field v-model="item.value" :disabled="item.isLoading"></v-text-field>
											</div>
											<div v-else dir="ltr" class="text-end">{{ item.value }}</div>
										</template>
										
										<template #[`item.actions`]="{ item }">
											<v-tooltip bottom>
												<template #activator="{ on }">
													<v-btn icon medium :disabled="loading" v-on="on" @click="deleteCommunication(item.id)">
														<v-icon color="error">mdi-comment-remove</v-icon>
													</v-btn>
												</template>
												<span>حذف</span>
											</v-tooltip>

											<v-tooltip bottom>
												<template #activator="{ on }">
													<v-btn icon medium :disabled="loading" v-on="on" @click="editCommunication(item)">
														<v-icon color="primary">mdi-pen</v-icon>
													</v-btn>
												</template>
												<span>تحرير</span>
											</v-tooltip>
										</template>
									</v-data-table>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-checkbox
										v-model="websiteNotification"
										label="استقبال الطلبات من على المنصة"
										true-value="1"
										false-value="0"
									></v-checkbox>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn
										color="primary"
										:disabled="communications.length == 0 && websiteNotification == 0"
										@click="step = 4"
									>
										حفظ
									</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<v-stepper-content step="4">
						<v-form v-model="valid2">
							<v-row dense>
								<v-col cols="12" class="text-center text-h5 pb-4">الدفع</v-col>
								<v-col cols="12">
									<v-skeleton-loader v-if="!terms" type="paragraph@2"></v-skeleton-loader>
									<pre v-else>{{ terms }}</pre>
								</v-col>
								<v-col v-if="terms" cols="12">
									<v-file-input
										v-model="paymentAttachment"
										accept="image/*"
										append-icon="mdi-camera"
										prepend-icon
										label="صورة الايصال"
										outlined
										hide-details="auto"
										:rules="[rules.optionalImage]"
									></v-file-input>
									
									<v-img v-if="receipt" class="mx-auto" :src="receipt" max-width="300" max-height="300" min-height="100"></v-img>
									
									<v-checkbox
										v-model="paymentSkipped"
										hide-details="auto"
										label="الدفع في وقت لاحق"
										:disabled="paymentAttachment != null || receipt != null"
									></v-checkbox>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn
										color="primary"
										class="mx-2 mb-2"
										:loading="loading"
										:disabled="(!paymentAttachment || !terms) && !receipt"
										@click="uploadPaymentAttachment('saveAndSubmit')"
									>
										حفظ وإرسال
									</v-btn>
									<v-btn
										color="primary"
										class="mx-2 mb-2"
										:loading="loading"
										:disabled="(!paymentSkipped && !paymentAttachment && !receipt) || (!terms && !receipt)"
										@click="uploadPaymentAttachment('saveDraft')"
									>
										حفظ كمسودة
									</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>

			<v-dialog v-model="showAddNewHospital" width="500">
				<v-card>
					<v-card-title primary-title>
						<v-spacer></v-spacer>
						<div>إضافة مستشفى جديد</div>
						<v-spacer></v-spacer>
					</v-card-title>
					<v-card-text>
						<v-form ref="addCompanyForm" v-model="valid3">
							<v-row dense>
								<v-col cols="12" class="py-0">
									<v-text-field
										v-model="newHospital.name"
										outlined
										label="اسم مقر العمل"
										:rules="[rules.required]"
									></v-text-field>
								</v-col>

								<v-col cols="12" class="text-center" @mouseover=";">
									<v-btn color="primary" :disabled="!valid3" :loading="loading" @click="addNewHospital">إضافة</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="showAddNewHospital2" width="500">
				<v-card>
					<v-card-title primary-title>
						<v-spacer></v-spacer>
						<div>إضافة مستشفى جديد</div>
						<v-spacer></v-spacer>
					</v-card-title>
					<v-card-text>
						<v-form ref="addCompanyForm" v-model="valid4">
							<v-row dense>
								<v-col cols="12" class="py-0">
									<v-text-field
										v-model="newHospital2.name"
										outlined
										label="اسم مقر العمل"
										:rules="[rules.required]"
									></v-text-field>
								</v-col>

								<v-col cols="12" class="text-center" @mouseover=";">
									<v-btn color="primary" :disabled="!valid4" :loading="loading" @click="addNewHospital2">إضافة</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="showAddNewSpecialty" width="500">
				<v-card>
					<v-card-title primary-title>
						<v-spacer></v-spacer>
						<div>إضافة فئة جديدة</div>
						<v-spacer></v-spacer>
					</v-card-title>
					<v-card-text>
						<v-form v-model="valid6">
							<v-row dense>
								<v-col cols="12" class="py-0">
									<v-text-field
										v-model="newSpecialty.name"
										outlined
										label="اسم الفئة"
										:rules="[rules.required]"
									></v-text-field>
								</v-col>

								<v-col cols="12" class="py-0">
									<v-text-field
										v-model="newSpecialty.femName"
										outlined
										label="اسم الفئة المؤنثة"
									></v-text-field>
								</v-col>

								<v-col cols="12" class="py-0">
									<v-text-field v-model="newSpecialty.description" outlined label="وصف الفئة"></v-text-field>
								</v-col>

								<v-col cols="12" class="text-center" @mouseover=";">
									<v-btn color="primary" :disabled="!valid6" :loading="loading" @click="addNewSpecialty">إضافة</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
				</v-card>
			</v-dialog>
		</v-container>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";
import { addBaseURL } from "@/utils/baseURL";

export default {
	filters: {
		imgToURL(val) {
			if (val) return URL.createObjectURL(val);
			return "";
		}
	},
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			search: null,
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					to: { name: "dashboard-home" }
				},
				{
					text: "النقل ببديل",
					exact: true,
					to: { name: "dashboard-replacement" }
				},
				{
					text: "الإضافة",
					disabled: true
				}
			],
			consent: false,
			loading: false,
			step: 0,
			contactsHeaders: [
				{ value: "communicationType", text: "نوع الاتصال" },
				{ value: "value", text: "المعرف" },
				{ value: "actions", text: "العمليات" }
			],
			sections: [],
			newRecord: {
				country: null,
				region: null,
				city: null,
				place: null,
				country3: null,
				region3: null,
				city3: null,
				place3: null,
				gender: "both",
				type: null,
				typeWritten: "",
				secondarySpecialties: [],
				section: null,
				requiredSections: [],
				note: ""
			},
			specialties: [],
			recordID: null,
			valid0: false,
			valid1: false,
			valid2: false,
			valid3: false,
			valid4: false,
			valid6: false,
			countries: [],
			regions: [],
			cities: [],
			places: [],

			regions2: [],
			cities2: [],
			places2: [],

			regions3: [],
			cities3: [],
			places3: [],

			conditions: null,
			newAttachment: {
				name: null,
				attachment: null,
				description: null
			},
			attachments: [],
			contactTypes: [],
			communications: [],
			newCommunication: {
				value: null,
				type: null
			},
			gender: "with",
			recordCities: {
				region: null,
				country: null,
				cities: []
			},
			storedRecordCities: [],
			selectedForRemoval: [],
			selectedForRemovalHospitals: [],
			websiteNotification: "1",
			terms: null,
			paymentSkipped: false,
			paymentAttachment: null,
			receipt: null,
			showAddNewHospital: false,
			showAddNewHospital2: false,
			newHospital: {
				name: null
			},
			newHospital2: {
				name: null
			},
			isOther: false,
			isFav: false,
			favHospitals: {},
			isEdit: false,
			added: false,
			missingRecord: false,
			showAddNewSpecialty: false,
			newSpecialty: {
				name: null,
				description: null,
				femName: null
			},
		};
	},
	computed: {
		selectedAll() {
			return this.recordCities.cities.length === this.cities2.length;
		},
		selectedSome() {
			return this.recordCities.cities.length > 0 && !this.selectedAll;
		},
		icon() {
			if (this.selectedAll) return "mdi-close-box";
			if (this.selectedSome) return "mdi-minus-box";
			return "mdi-checkbox-blank-outline";
		},
		specialtyName() {
			if (this.specialties.length && this.newRecord.specialty) {
				const spec = this.specialties.find(spec => spec.specialtiesID == this.newRecord.specialty);
				if (spec && spec.name) {
					return spec.name;
				} else {
					return  "...";
				}
			} else {
				return "...";
			}
		}
	},
	watch: {
		step () {
			this.$vuetify.goTo(0);
		},
		"newRecord.country"(newVal) {
			this.newRecord.region = null;
			this.regions = [];
			this.getRegions(newVal);
		},
		"newRecord.region"(newVal) {
			this.newRecord.city = null;
			this.cities = [];
			this.getCities(newVal);
		},
		"newRecord.city"(newVal) {
			this.newRecord.place = null;
			this.places = [];
			this.getPlaces(newVal);
		},

		"newRecord.country3"(newVal) {
			this.newRecord.region3 = null;
			this.regions3 = [];
			this.getRegions3(newVal);
		},
		"newRecord.region3"(newVal) {
			this.newRecord.city3 = null;
			this.cities3 = [];
			this.getCities3(newVal);
		},
		"newRecord.city3"(newVal) {
			this.newRecord.place3 = null;
			this.places3 = [];
			this.getPlaces3(newVal);
		},

		"recordCities.country"(newVal) {
			this.recordCities.region = null;
			this.regions2 = [];
			this.getRegionsForRecordCities(newVal);
		},
		"recordCities.region"(newVal) {
			this.recordCities.cities = [];
			this.cities2 = [];
			this.getCitiesForRecordCities(newVal);
		},
		"recordCities.cities"(newVal) {
			this.recordCities.places = [];
			this.places2 = [];
			if (newVal.length == 1) {
				this.getPlacesForRecordCities(newVal[0].cityID);
			}
		},
		"newCommunication.type"(newVal) {
			if (newVal) {
				var type = this.contactTypes.find(
					com => com.communicationTypeID == newVal
				);
				if (type.initialProfilesPath == null) {
					type.initialProfilesPath = "";
				}
				this.newCommunication.value = "" + type.initialProfilesPath;
			}
		},
		"newRecord.requiredSections"(newVal) {
			if (newVal && newVal.length) {
				var newItem = newVal[newVal.length - 1];
				if (this.sections.indexOf(newItem) == -1) {
					this.sections.push(newItem);
				}
			}
		}
	},
	mounted() {
		if (this.$route.params.recordID) {
			console.log("edit");
			this.isEdit = true;
			this.recordID = this.$route.params.recordID;
			this.consent = true;
			this.step = 1;
			this.breadcrumbs[2].text = "التعديل";
		} else {
			console.log("not edit");
		}

		if (!this.isEdit) {
			this.getConditions();
		}

		if (this.isEdit) {
			this.getPreviousInfo();
		}

		this.getSpecialties();
		// this.getCountries();
		this.countries = [
			{
				countryID: "sa",
				name: "المملكة العربية السعودية"
			}
		];
		this.newRecord.country = "sa";
		this.newRecord.country3 = "sa";
		this.recordCities.country = "sa";
		this.getContactTypes();
		this.getTerms();
	},
	methods: {
		deleteCommunication(comID) {
			this.loading = true;

			clientNotifier
				.delete("/api/communication/delete/" + comID)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");

					var index = this.communications.findIndex(
						com => com.id == comID
					);
					this.communications.splice(index, 1);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		addNewSpecialty() {
			this.loading = true;
			var data = {
				...this.newSpecialty
			};
			client
				.post("/api/replacements/newSpecialties", data)
				.then(response => {
					this.$store.dispatch("notify", {
						message: "تم الحفظ"
					});
					var newSpec = {
						name: this.newSpecialty.name,
						specialtiesID: response.data.data.id,
						femName: this.newSpecialty.femName,
					};
					this.specialties.push(newSpec);
					this.newRecord.specialty = newSpec.specialtiesID;
					this.showAddNewSpecialty = false;
					this.newSpecialty = {
						name: null,
						description: null,
						femName: null
					};
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getPreviousInfo() {
			clientNotifier
				.get("/api/replacements/show/" + this.recordID)
				.then(response => {
					console.log(response);
					var newData = response.data.data[0];

					this.title = newData.title;
					this.description = newData.description;
					this.content = newData.body;

					newData.communications = newData.communications.map(
						comm => {
							if (comm.note == "null") {
								comm.note = null;
							}

							if (comm.name == "Telephone") {
								comm.value = "tel:" + comm.value;
							} else if (comm.name == "رقم الجوال") {
								comm.value = "tel:" + comm.value;
							} else if (comm.name == "البريد الإلكتروني") {
								comm.value = "mailto:" + comm.value;
							}

							comm.isEdit = false;
							return comm;
						}
					);

					if (newData.attachments) {
						this.attachments = newData.attachments;
					}

					if (newData.communications) {
						this.communications = newData.communications.map(e => {
							e.communicationType = e.name;
							return e;
						});
					}

					this.isOther = newData.originalPlace.length != 0

					this.newRecord = {
						country: newData.place[0]?.countryID || 'sa',
						region: newData.place[0]?.regionID,
						city: newData.place[0]?.cityID,
						place: newData.place[0]?.placeID,

						country3: newData?.originalPlace[0]?.countryID || 'sa',
						region3: newData?.originalPlace[0]?.regionID,
						city3: newData?.originalPlace[0]?.cityID,
						place3: newData?.originalPlace[0]?.placeID,
						
						specialty: newData.specialtiesID,
						secondarySpecialties: newData.otherSpecialtiesIDs || [],
						section: newData.section != "null" ? newData.section : null,
						requiredSections: newData.requiredSections || [],
						note: newData.note != "null" ? newData.note : null
					};

					this.$nextTick(() => {
						if (this.cities.length == 0 && newData.place[0]?.cityID) {
							this.cities = [{
								cityID: newData.place[0].cityID,
								name: newData.place[0].cityName
							}]
						}
						this.newRecord.city = newData.place[0]?.cityID

						if (this.cities3.length == 0 && newData.originalPlace[0]?.cityID) {
							this.cities3 = [{
								cityID: newData.originalPlace[0]?.cityID,
								name: newData.originalPlace[0]?.cityName
							}]
						}
						this.newRecord.city3 = newData.originalPlace[0]?.cityID

						this.$nextTick(() => {
							if (this.places.length == 0 && newData.place[0]?.placeID) {
								this.places = [{
									placeID: newData.place[0]?.placeID,
									name: newData.place[0]?.placeName
								}]
							}
							this.newRecord.place = newData.place[0]?.placeID

							if (this.places3.length == 0 && newData.originalPlace[0]?.placeID) {
								this.places3 = [{
									placeID: newData.originalPlace[0]?.placeID,
									name: newData.originalPlace[0]?.placeName
								}]
							}
							this.newRecord.place3 = newData.originalPlace[0]?.placeID
						})
					})

					if (newData.transferType == "تشغيل ذاتي") {
						this.newRecord.type = newData.transferType;
						this.newRecord.typeWritten = "";
					} else if (newData.transferType == "خدمة مدنية") {
						this.newRecord.type = newData.transferType;
						this.newRecord.typeWritten = "";
					} else {
						this.newRecord.type = "other";
						this.newRecord.typeWritten = newData.transferType;
					}

					if (newData.maleReplacement && newData.femaleReplacement) {
						this.newRecord.gender = "both";
					} else if (newData.maleReplacement) {
						this.newRecord.gender = "male";
					} else {
						this.newRecord.gender = "female";
					}

					if (newData.toCities) {
						this.storedRecordCities = newData.toCities.map(city => {
							city.name = city.cityName;
							return city;
						})
						this.favHospitals = newData.toCities
					}

					console.log(newData.reciveRequests)
					if(newData.reciveRequests){
						this.websiteNotification = "1"
					} else {
						this.websiteNotification = "0"
					}
					
					this.getReceipt()

					setTimeout(() => {
						// on next tick, 0ms is enough
						this.valid1 = true;
					}, 100);
				})
				.catch(err => {
					this.missingRecord = true;
					console.log(err);
				});
		},
		getReceipt() {
			this.actionLoading = true;
			client
				.get("/api/replacements/gettransfercopy/" + this.recordID)
				.then(response => {
					console.log(response);
					if(response.data.data != "https://ertiqa.v2.svod.app/storage"){
						this.receipt = addBaseURL(response.data.data);
					}
				})
				.finally(() => {
					this.actionLoading = false;
				});
		},
		getTerms() {
			client
				.get("/api/replacements/payment")
				.then(response => {
					this.terms = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getConditions() {
			client
				.get("/api/replacements/getconditions")
				.then(response => {
					this.loading = false;
					this.conditions = response.data.data;
					this.conditions = this.conditions || "...";
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		toggleAll() {
			this.$nextTick(() => {
				if (this.selectedAll) {
					this.recordCities.cities = [];
				} else {
					this.recordCities.cities = this.cities2.slice();
				}
			});
		},
		getSpecialties() {
			client
				.get("/api/replacements/specialtiesList")
				.then(response => {
					this.specialties = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCountries() {
			client
				.get("/api/location/countries")
				.then(response => {
					this.countries = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getRegions(countryID) {
			client
				.post("/api/location/countryregions", { countryID: countryID })
				.then(response => {
					this.regions = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCities(regionID) {
			client
				.post("/api/location/regioncities", { regionID: regionID })
				.then(response => {
					this.cities = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getPlaces(cityID) {
			client
				.post("/api/location/hospitals", { cityID: cityID })
				.then(response => {
					this.places = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getRegions3(countryID) {
			client
				.post("/api/location/countryregions", { countryID: countryID })
				.then(response => {
					this.regions3 = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCities3(regionID) {
			client
				.post("/api/location/regioncities", { regionID: regionID })
				.then(response => {
					this.cities3 = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getPlaces3(cityID) {
			client
				.post("/api/location/hospitals", { cityID: cityID })
				.then(response => {
					this.places3 = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getRegionsForRecordCities(countryID) {
			client
				.post("/api/location/countryregions", { countryID: countryID })
				.then(response => {
					this.regions2 = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCitiesForRecordCities(regionID) {
			client
				.post("/api/location/regioncities", { regionID: regionID })
				.then(response => {
					this.cities2 = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getPlacesForRecordCities(cityID) {
			client
				.post("/api/location/hospitals", { cityID: cityID })
				.then(response => {
					this.places2 = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		submitStep1() {
			this.loading = true;

			var male =
				this.newRecord.gender == "both" ||
				this.newRecord.gender == "male";

			var female =
				this.newRecord.gender == "both" ||
				this.newRecord.gender == "female";

			male = male ? 1 : 0;
			female = female ? 1 : 0;

			var data = new FormData();
			data.append("placeID", this.newRecord.place);
			if (this.isOther) {
				data.append("originalPlaceID", this.newRecord.place3);
			} else {
				// data.append("originalPlaceID", null);
			}

			if (this.newRecord.type == "other") {
				data.append("transferType", this.newRecord.typeWritten);
			} else {
				data.append("transferType", this.newRecord.type);
			}
			data.append("specialtiesID", this.newRecord.specialty);
			data.append("note", this.newRecord.note);
			data.append("maleReplacement", male);
			data.append("femaleReplacement", female);
			data.append("reciveRequests", 0);
			data.append("section", this.newRecord.section);

			if (this.isEdit) {
				data.append("id", this.recordID);
				clientNotifier
					.post("/api/replacements/update", data)
					.then(() => {
						this.step = 2;
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				clientNotifier
					.post("/api/replacements/insert", data)
					.then(response => {
						this.recordID = response.data.data.id;
						this.isEdit = true;
						this.added = true;
						this.step = 2;
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},
		submitStep2() {
			this.loading = true;

			var data = new FormData();
			data.append("id", this.recordID);
			data.append(
				"otherSpecialtiesIDs",
				JSON.stringify(this.newRecord.secondarySpecialties)
			);
			data.append(
				"requiredSections",
				JSON.stringify(this.newRecord.requiredSections)
			);
			client
				.post("/api/replacements/update", data)
				.then(response => {
					this.step = 3;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		addRecordCities() {
			this.loading = true;

			var data = {
				replacementID: this.recordID,
				cities: this.recordCities.cities.map(c => c.cityID)
			};

			var city = this.recordCities.cities.map(c => c.cityID)[0];
			var hospitals = this.recordCities.places.map(c => c.id);

			if (hospitals.length) {
				data.hospitalsID = JSON.stringify(hospitals);
			}

			client
				.post("/api/replacements/addcities", data)
				.then(response => {
					console.log(response);
					var ids = this.storedRecordCities.map(c => c.cityID);
					var favHospitalIds = [];

					if (hospitals.length) {
						if (
							this.favHospitals[city] &&
							this.favHospitals[city].hospitals
						) {
							favHospitalIds = this.favHospitals[
								city
							].hospitals.map(h => h.id);
						}
						this.recordCities.places.forEach(hospital => {
							console.log(this.favHospitals[city]);
							if (favHospitalIds.indexOf(hospital.id) == -1) {
								if (this.favHospitals[city]) {
									this.favHospitals[city].hospitals.push(
										hospital
									);
								} else {
									this.favHospitals[city] = {
										city: city,
										name: this.recordCities.cities[0].name,
										hospitals: [hospital]
									};
								}
							}
						});
					} else {
						this.recordCities.cities.forEach(city => {
							if (ids.indexOf(city.cityID) == -1) {
								this.storedRecordCities.push(city);
							}
						});
					}

					this.recordCities.cities = [];
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		removeRecordCities() {
			if (
				this.selectedForRemoval.length == 0 &&
				this.selectedForRemovalHospitals.length == 0
			) {
				return;
			}

			this.loading = true;

			this.selectedForRemoval.push(...this.selectedForRemovalHospitals);
			this.selectedForRemoval.forEach(cityToBeRemoved => {
				var data = {
					replacementID: this.recordID,
					cityID: cityToBeRemoved
				};

				client
					.post("/api/replacements/deletecity", data)
					.then(response => {
						console.log(response);
						this.storedRecordCities = this.storedRecordCities.filter(
							city => {
								var toKeep = false;
								if (cityToBeRemoved != city.cityID) {
									toKeep = true;
								}

								if (!toKeep) {
									var cityWithHospitals = this.favHospitals[
										cityToBeRemoved
									];
									if (cityWithHospitals) {
										cityWithHospitals.hospitals = [];
									}
								}

								return toKeep;
							}
						);

						var newFavHospitals = {};

						Object.keys(this.favHospitals).forEach(key => {
							if (this.favHospitals[key].hospitals.length) {
								newFavHospitals[key] = this.favHospitals[key];
							}
						});

						this.favHospitals = newFavHospitals;
					})
					.catch(err => {
						console.log(err);
					})
					.finally(() => {
						this.loading = false;
					})
			});
		},
		getContactTypes() {
			client
				.get("/api/communication/types")
				.then(response => {
					this.contactTypes = response.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		addContact() {
			this.loading = true;
			var data = new FormData();
			data.append("relatedID", "RP" + this.recordID);
			data.append("relatedModel", "replacements");
			data.append("communicationTypeID", this.newCommunication.type);
			data.append("value", this.newCommunication.value);
			data.append("note", "");

			client
				.post("/api/communication/new", data)
				.then(response => {
					var type = this.contactTypes.find(
						com =>
							com.communicationTypeID ==
							this.newCommunication.type
					);
					this.communications.push({
						...this.newCommunication,
						id: response.data,
						communicationType: type.name,
						isEdit: false
					});
					this.newCommunication = {
						value: null,
						type: null
					};
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		uploadPaymentAttachment(next) {
			this.loading = true;
			if (!this.paymentAttachment) {
				if (next == "saveAndSubmit") {
					this.saveAndSubmit();
				} else {
					this.saveDraft();
				}
				return;
			}

			var data = new FormData();
			data.append("replacementID", this.recordID);
			data.append("attachment", this.paymentAttachment);
			client
				.post("/api/replacements/settransfercopy", data)
				.then(response => {
					if (next == "saveAndSubmit") {
						this.saveAndSubmit();
					} else {
						this.saveDraft();
					}
					console.log(response);
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "حدثت مشكلة اثناء رفع الملف",
						color: "error"
					});
					this.loading = false;
				});
		},
		saveAndSubmit() {
			this.loading = true;

			var url = this.recordID + "/" + this.websiteNotification;
			client
				.post("/api/replacements/recive/" + url)
				.then(response => {
					this.submitRecord();
					console.log(response);
				})
				.catch(err => {
					console.log(err);
					this.loading = false;
				});
		},
		saveDraft() {
			this.loading = true;

			var url = this.recordID + "/" + this.websiteNotification;
			clientNotifier
				.post("/api/replacements/recive/" + url)
				.then(() => {
					this.$router.push({ name: "dashboard-replacement-manage" });
				})
				.finally(() => {
					this.loading = false;
				});
		},
		submitRecord() {
			this.loading = true;
			clientNotifier
				.post("/api/replacements/submit/" + this.recordID)
				.then(() => {
					this.$router.push({ name: "dashboard-replacement-manage" });
				})
				.finally(() => {
					this.loading = false;
				});
		},
		addNewHospital() {
			this.loading = true;
			var data = {
				...this.newHospital,
				// isHospital: 1,
				cityID: this.newRecord.city
			};
			client
				.post("/api/location/addhospital", data)
				.then(response => {
					this.$store.dispatch("notify", {
						message: "تم الحفظ"
					});
					this.places.push({
						name: this.newHospital.name,
						id: response.data.data.id
					});
					this.newRecord.place = response.data.data.id;
					this.showAddNewHospital = false;
					this.newHospital = {
						name: null
					};
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		addNewHospital2() {
			this.loading = true;
			var data = {
				...this.newHospital2,
				// isHospital: 1,
				cityID: this.newRecord.city
			};
			client
				.post("/api/location/addhospital", data)
				.then(response => {
					this.$store.dispatch("notify", {
						message: "تم الحفظ"
					});
					this.places3.push({
						name: this.newHospital2.name,
						id: response.data.data.id
					});
					this.newRecord.place3 = response.data.data.id;
					this.showAddNewHospital2 = false;
					this.newHospital2 = {
						name: null
					};
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		editCommunication(item){
			if(item.isEdit) {
				this.updateInfo(item)
			} else {
				item.isEdit = true;
			}
		},
		updateInfo(item) {
			item.isLoading = true;

			const data = {
				communicationInfoID: item.id,
				value: item.value,
				// note: item.note,
			}

			clientNotifier
				.post("/api/communication/update", data)
				.then(() => {
					item.isEdit = false;
				})
				.finally(() => {
					item.isLoading = false;
				});
		},
	}
};
</script>

<style scoped>
.ltr-content ::v-deep input {
	direction: ltr;
}
</style>